import { NgForm } from '@angular/forms';

export function markFormAsTouched(form: NgForm) {
  for (const control of Object.values(form.controls)) {
    control.markAsTouched();
  }
}
